// extracted by mini-css-extract-plugin
export default {"meal":"Mealitem_meal__WhkXe","description":"Mealitem_description__Tc0Ea","price":"Mealitem_price__OTbga"};